var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 450.4 390.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient9);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st8 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st9 {\n        fill: url(#linear-gradient11);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st11 {\n        fill: #231f20;\n      }\n\n      .st12 {\n        fill: url(#radial-gradient);\n      }\n\n      .st13 {\n        fill: url(#linear-gradient);\n      }\n\n      .st14 {\n        fill: #1d1d1b;\n      }\n\n      .st15 {\n        isolation: isolate;\n      }\n\n      .st16 {\n        fill: #fff;\n      }\n\n      .st17 {\n        stroke: #fff;\n        stroke-width: 4.5px;\n      }\n\n      .st17, .st18, .st19, .st20 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st18 {\n        stroke-width: 1.1px;\n      }\n\n      .st18, .st19, .st20, .st21 {\n        stroke: #000;\n      }\n\n      .st19 {\n        stroke-width: 1.6px;\n      }\n\n      .st20 {\n        stroke-width: 1.8px;\n      }\n\n      .st22 {\n        opacity: .2;\n      }\n\n      .st23 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st24 {\n        fill: url(#radial-gradient6);\n      }\n\n      .st25 {\n        fill: url(#radial-gradient8);\n      }\n\n      .st26 {\n        fill: url(#radial-gradient3);\n      }\n\n      .st27 {\n        fill: url(#radial-gradient2);\n      }\n\n      .st28 {\n        fill: url(#radial-gradient5);\n      }\n\n      .st29 {\n        fill: url(#radial-gradient4);\n      }\n\n      .st30 {\n        fill: url(#radial-gradient7);\n      }\n\n      .st31 {\n        display: none;\n      }\n\n      .st21 {\n        fill: #1a1a1a;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 247,
    y1: -2079,
    x2: 247,
    y2: -1829.4,
    gradientTransform: "translate(0 -1828) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 225.2,
    cy: 3728.8,
    fx: 225.2,
    fy: 3728.8,
    r: 141.5,
    gradientTransform: "translate(0 -3538.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7d7d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 809.3,
    cy: -1519.7,
    fx: 809.3,
    fy: -1519.7,
    r: 167.7,
    gradientTransform: "translate(-506.8 -1376) scale(.9 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005bb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#003d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00358b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00173e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00050f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: 225.2,
    cy: -1575.1,
    fx: 225.2,
    fy: -1575.1,
    r: 141.5,
    gradientTransform: "translate(0 -1376) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7d7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 227,
    y1: -1497.7,
    x2: 227.3,
    y2: -1612.2,
    gradientTransform: "translate(0 -1376) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 322,
    y1: -1491.7,
    x2: 128.2,
    y2: -1491.7,
    gradientTransform: "translate(0 -1376) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: -9755.7,
    y1: 3697.9,
    x2: -9852.8,
    y2: 3697.9,
    gradientTransform: "translate(-9508.4 -3450.6) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 535,
    y1: 3697.9,
    x2: 437.9,
    y2: 3697.9,
    gradientTransform: "translate(-331.1 -3450.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cx: 964.1,
    cy: -1606,
    fx: 964.1,
    fy: -1606,
    r: 32.1,
    gradientTransform: "translate(-534 -1405.3) rotate(-2.2) scale(.9 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005bb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#003d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00358b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00173e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00050f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient4",
    cx: 56.8,
    cy: 124.3,
    fx: 56.8,
    fy: 124.3,
    r: 35.4,
    gradientTransform: "translate(0 277.7) scale(1 -.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005bb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#003d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00358b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00173e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00050f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 244.8,
    y1: -2061.6,
    x2: 244.8,
    y2: -1812,
    gradientTransform: "translate(0 -1828) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient5",
    cx: 223,
    cy: 1943.4,
    fx: 223,
    fy: 1943.4,
    r: 141.5,
    gradientTransform: "translate(0 392) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7d7d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient6",
    cx: 618.3,
    cy: -1502.3,
    fx: 618.3,
    fy: -1502.3,
    r: 167.7,
    gradientTransform: "translate(0 392) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005bb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#003d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00358b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00173e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00050f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient7",
    cx: 223,
    cy: -1557.7,
    fx: 223,
    fy: -1557.7,
    r: 141.5,
    gradientTransform: "translate(0 -1376) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 295.7,
    y1: 137,
    x2: 181.6,
    y2: 137,
    gradientTransform: "translate(0 392) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient8",
    cx: 224.9,
    cy: -1537.4,
    fx: 224.9,
    fy: -1537.4,
    r: 121.5,
    gradientTransform: "translate(0 -1376) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: -9753.5,
    y1: 3680.5,
    x2: -9850.6,
    y2: 3680.5,
    gradientTransform: "translate(-9508.4 -3450.6) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 532.8,
    y1: 3680.5,
    x2: 435.7,
    y2: 3680.5,
    gradientTransform: "translate(-331.1 -3450.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 350.4,
    y1: -1479.8,
    x2: 101.6,
    y2: -1479.8,
    gradientTransform: "translate(0 -1376) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 410.4,
    y1: 298,
    x2: 433.5,
    y2: 298,
    gradientTransform: "translate(-44.9 438.9) rotate(2.3) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: -2795.2,
    y1: 169.2,
    x2: -2772.1,
    y2: 169.2,
    gradientTransform: "translate(-2713.1 438.9) rotate(177.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaeaea"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer_1",
    className: "st31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_111",
    className: "st31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M324.2,261.6s-3.6,23.5-47.5,41c-39.4,15.6-61.5,5.3-61.5,5.3,0,0,8.9,8.7,44.6,4.7,33.3-3.7,59.3-25.6,67.4-43,0,0,6.6,5.5,7.2,1.9s-8.8-8.7-10.2-9.8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M9.1,152.7c-4,2.3-6.5,6.6-6.3,11.2l.9,43.6c0,4.6,2.7,8.8,6.8,10.9,0,0,31.7,15.8,32.9,15.4-5.1-10.1-7.9-21.3-8.2-32.7-.2-19.4-3.3-47.6,6-65.1-1.3-.2-32.2,16.7-32.2,16.7h.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M359.6,135.2v39.1c0,17.3-14,31.3-31.3,31.3h-48.5c-8.9-31.1-41.2-49.1-72.3-40.2-19.5,5.6-34.7,20.8-40.2,40.2h-48.4c-17.3,0-31.3-14-31.3-31.3v-39.1c0-17.3,14-31.3,31.3-31.3h209.4c17.3,0,31.3,14,31.3,31.3h0ZM406.7,174.2c0,42.4-34.4,76.8-76.8,76.8h-68.4c-6,0-11.5-3.6-13.9-9.1l-11.3-26.2c-2.8-6.1-10-8.9-16.1-6.1-2.7,1.2-4.9,3.4-6.1,6.1l-11.4,26.1c-2.4,5.6-7.9,9.2-13.9,9.2h-68.3c-42.4-.1-76.7-34.4-76.8-76.8.5-21-3-54.2,7.9-72.9v-14.5C50.9,42.1,85.6.8,128.3,1.4h193.8c42.7-.6,77.3,40.7,76.7,85.3v14.6c10.9,18.5,7.4,52.1,7.9,72.9h0ZM374.7,135.2c0-25.7-20.8-46.4-46.5-46.5H118.8c-25.7,0-46.4,20.8-46.5,46.5v39.1c0,25.7,20.8,46.4,46.5,46.5h53.4c3,0,5.8-1.8,7-4.6l5.5-12.5c9.6-21.5,34.8-31.1,56.3-21.5,9.6,4.3,17.2,12,21.5,21.6l5.3,12.4c1.2,2.8,4,4.6,7,4.6h53.5c25.7,0,46.5-20.8,46.5-46.5v-39.1h0ZM381.7,80.1c-.7-8.1-2.6-16-5.6-23.5-8.8-23.3-30.7-39.1-55.6-40H126.6c-33-.5-59.3,30.8-61.3,63.5,14.3-14,33.5-21.8,53.5-21.8h209.4c20,0,39.2,7.8,53.5,21.8ZM440.4,150s-32.2-14.2-33.5-13.9c10.8,16.6,10,45,11.5,64.3.7,11.3-1.1,22.7-5.4,33.2,1.3.2,31.5-18.1,31.5-18.1,3.9-2.4,6.2-6.8,5.9-11.4l-2.8-43.5c-.3-4.6-3.1-8.7-7.3-10.6h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M215.2,341H70.2V31.1h310.1v146.3c-.3-4.7-1.3-11.3-2.1-16.2-10.1-61.8-57.6-111.5-118.4-125.5-.3,1.7.3,1.1,1.4,1.5,4.4,1.4,9,2.5,13.4,4,51.5,18.5,90.3,65,96.6,119.9,6.7,58-22.7,93.1-65.4,126.5-47,36.8-111.6,38.8-159.2,1.9-24.1-18.6-55.1-47.6-63.3-77.8-18.2-66.2,17.8-135.8,78.5-164.8,6.2-3,12.5-4.6,18.7-7.1s2.6-.7,2.6-1.6c-19.9,5.2-39.1,15.5-55.1,28.4-108.8,87.9-51.6,265.4,87.3,274.5h0ZM99,173.3c.8-.7,3.8-7.5,5.1-9.4,11.5-17.8,27.1-29.5,49.2-22.3,2.6.8,9.9,5.4,10.7,5.5,2.2.2,2.7-1.6,2.1-3.4s-11.4-6.5-14.1-7.2c-22.5-6-39.6,5.8-51.4,24-1.6,2.5-8.2,11.7-4.6,13.4.9.5,2.4.1,3-.5h0ZM352,173.3c.7.7,2.1,1,3,.5.9-.6,1.4-1.4,1.3-2.6-.1-1.8-5.8-10.8-7.2-12.8-12-17.2-28.5-27.8-50.2-22-2.7.7-13.4,4.8-14.1,7.2s-.1,3.7,2.1,3.4,8.1-4.6,10.7-5.5c22.2-7.2,37.7,4.4,49.2,22.3s4.3,8.7,5.1,9.4h.1ZM119.8,203.8c9.5-1.4,19.8-2.7,29.4-2s5.2,2.3,8.1,8c4.6,8.9,17,10.9,25,5.2s8.3-27.8-6.1-29.3-44,1.3-55.4,16.1c-.5.6-1.3.8-1,1.9h0ZM262.3,203.8c11.4-1.9,23-3.2,34.4-1.2l.8.5c2.1,12.1,13,18.4,24.4,13.5s12.6-29.4-3.7-30.9-40.3,1.1-51.9,12.6c-.5.5-4.3,5.1-3.8,5.5h-.2,0ZM284.2,238.6c-1.3-1.3-1.9,3.7-2.3,4.5-13.1,31.2-58.9,38.5-88.9,38.7-4.3,0-13.8-1.8-17.3-.6s-3.4,8.4-.4,9.9c24.7,0,51.1,2.3,75.3-3.3,25.8-6,44.9-20.1,33.6-49.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M380.2,195.4v145.6h-144.4c5.1-1.2,10.4-1.3,15.6-2.1,65-10.9,116.4-62.8,126.8-127.8l2-15.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_31",
    className: "st31"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 225.2,
    cy: 190.7,
    r: 141.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M67.5,118.9l-25.6,14.7c-4.1,2.4-6.7,7.1-6.7,12.1v47.5c0,5,2.5,9.7,6.7,12l25.7,14.8c-4.3-10.4-6.5-21.7-6.5-33,.4-19.9-2.3-49.9,6.4-68.1h0ZM380.2,187c0,38.2-29,69.2-64.8,69.3h-57.7c-5.1,0-9.6-3.2-11.7-8.2l-9.5-23.6c-2.3-5.5-8.4-8-13.7-5.5-2.2,1.1-4.1,3-5.1,5.5l-9.6,23.5c-2,5-6.6,8.3-11.8,8.3h-57.6c-35.7,0-64.7-31-64.8-69.3.4-18.9-2.5-48.9,6.6-65.8v-13.1c-.6-40.3,28.7-77.5,64.7-77h163.5c36-.5,65.2,36.7,64.7,76.9v13.1c9.2,16.7,6.3,46.9,6.6,65.8h.2,0ZM360.4,102.2c-.6-7.3-2.2-14.4-4.8-21.2-7.4-21.1-25.9-35.3-47-36.1h-163.5c-27.8-.4-50,27.8-51.6,57.3,12.1-12.6,28.2-19.7,45.1-19.6h176.7c16.8,0,33,7,45.1,19.6h0ZM418.6,133.6s-31.9-17.7-33.2-17.4c9.9,18.8,7.3,49.7,7.6,70.8,0,12.4-2.6,24.6-7.6,35.8,1.3.4,33.3-17.6,33.3-17.6,4.1-2.4,6.7-7,6.7-12v-47.5c0-5-2.5-9.7-6.7-12.1h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.5,238.6c11.3,29.1-7.8,43.2-33.6,49.2-24.2,5.6-50.6,3.3-75.3,3.3-3-1.5-2.2-9,.4-9.9s13,.6,17.3.6c30-.2,75.8-7.5,88.9-38.7.3-.8,1-5.8,2.3-4.5h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_211"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 183.8,
    y1: 98.8,
    x2: 266.7,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_311"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 225.2,
    cy: 190.7,
    r: 141.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373.3,121.2c9.2,16.7,7,46.9,6.9,65.8h-.2.2c0,38.2-29,69.2-64.8,69.3h-57.7c-5.1,0-9.6-3.2-11.7-8.2l-9.5-23.6c-2.3-5.5-8.4-8-13.7-5.5-2.2,1.1-4.1,3-5.1,5.5l-9.6,23.5c-2,5-6.6,8.3-11.8,8.3h-57.6c-35.7,0-64.7-31-64.8-69.3.4-18.9-2.5-48.9,6.6-65.8M148.2,121.2h-67.8c11-22.3,54.3-19.8,71.2-19.7h176.7c16.8,0,35,5.6,45,19.7h0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.6,235.2c11.3,29.1-7.8,43.2-33.6,49.2-24.2,5.6-50.6,3.3-75.3,3.3-3-1.5-2.2-9,.4-9.9s13,.6,17.3.6c30-.2,75.8-7.5,88.9-38.7.3-.8,1-5.8,2.3-4.5h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.8,118.1c25.8-11.9,58.8-10.1,87.9-10.5,22.9.2,46.7-.7,69.2,3.2,9.8,1.6,34.3,8.7,29.5,11.4-2.3.9-11.1,0-15.2-.4-7.6-.8-16.2-1.7-23.9-2.3-19.4-1.4-35.4-1.7-55.3-1.8-18.7,0-37.3,0-56.1,1.6-6.8.6-13.8,1.5-20.6,2.5-7,1-34.3,5.3-15.7-3.7h.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.3,246c-14.2,6.8-30.4,6-46.2,6.3-7.5,0-16.6.7-25.1.7s-19,.3-22.6-9.6c-.7-4.4,4.1.9,6.1,2.5,2.9,2.4,6.6,3,10.2,3.1,4.7.1,9.7,0,14.5,0,14.3-.2,29.9.3,44.2-1.3,2.8-.3,5.9-.7,8.6-1.3,2.1-.4,20.2-6,10.7-.6l-.3.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M109.8,246c14.2,6.8,30.4,6,46.2,6.3,7.5,0,16.6.7,25.1.7s19,.3,22.6-9.6c.7-4.4-4.1.9-6.1,2.5-2.9,2.4-6.6,3-10.2,3.1-4.7.1-9.7,0-14.5,0-14.3-.2-29.9.3-44.2-1.3-2.8-.3-5.9-.7-8.6-1.3-2.1-.4-20.2-6-10.7-.6l.3.2h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M406.7,135.3s-27.1-13.7-28.2-13.4c8.8,15.3,7.7,41.1,8.6,58.6.4,10.3-1.4,20.5-5.2,30,1.1.3,27.1-15.7,27.1-15.7,3.3-2.1,5.3-6,5.2-10.2l-1.5-39.5c-.2-4.2-2.4-8-6-9.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M73.7,121.2l-25.6,13.3c-4.1,2.2-6.7,6.4-6.7,11v43.1c0,4.5,2.5,8.8,6.7,10.9l25.7,13.4c-4.3-9.4-6.5-19.7-6.5-29.9.4-18.1-2.3-45.3,6.4-61.8h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_311",
    "data-name": "Layer_31",
    className: "st31"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 128.4,
    y1: 278.4,
    x2: 128.4,
    y2: 305.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 164.1,
    y1: 295.7,
    x2: 164.1,
    y2: 334.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 145.9,
    y1: 288.1,
    x2: 145.9,
    y2: 318.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 185.6,
    y1: 301.8,
    x2: 185.6,
    y2: 353.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 209.3,
    y1: 305.3,
    x2: 209.3,
    y2: 340.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 223,
    y1: 305.7,
    x2: 223,
    y2: 322.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 252.9,
    y1: 303.2,
    x2: 252.9,
    y2: 343.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 287.3,
    y1: 292.9,
    x2: 287.3,
    y2: 328.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 269.9,
    y1: 299.3,
    x2: 269.9,
    y2: 327.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 330.1,
    y1: 261.1,
    x2: 330.1,
    y2: 288.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 308.9,
    y1: 282.3,
    x2: 308.9,
    y2: 338
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 320.5,
    y1: 274.8,
    x2: 320.5,
    y2: 309.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 237.5,
    y1: 314.1,
    x2: 237.5,
    y2: 334.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_411",
    "data-name": "Layer_41",
    className: "st31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "338.3 254.4 336.1 357.7 333.9 254.4 338.3 254.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "303.9 256.4 301.7 359.7 299.4 256.4 303.9 256.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "319.5 236.7 317.2 345.3 314.8 236.7 319.5 236.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "270.1 241.5 268.2 333.8 266.2 241.5 270.1 241.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "290.7 233.5 288.5 336.7 286.3 233.5 290.7 233.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "260.1 244.2 258.5 321.8 256.9 244.2 260.1 244.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "244.5 260.6 242.5 354.4 240.5 260.6 244.5 260.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "228.3 247.4 226.5 333.6 224.7 247.4 228.3 247.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "212.3 253.2 210 359.4 207.8 253.2 212.3 253.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "186.9 235.2 184.8 334.4 182.7 235.2 186.9 235.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "196 256.1 194 351 192 256.1 196 256.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "133.5 237.7 131.7 322.1 129.9 237.7 133.5 237.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "157.7 235.6 155.7 331.8 153.6 235.6 157.7 235.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "146.3 250.2 144.5 335.5 142.7 250.2 146.3 250.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "114.5 254.1 112.6 344.1 110.7 254.1 114.5 254.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "172.5 253.3 170.4 353.9 168.2 253.3 172.5 253.3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_211",
    "data-name": "Layer_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_113",
    className: "st31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M322,244.2s-3.6,23.5-47.5,41c-39.4,15.6-61.5,5.3-61.5,5.3,0,0,8.9,8.7,44.6,4.7,33.3-3.7,59.3-25.6,67.4-43,0,0,6.6,5.5,7.2,1.9s-8.8-8.7-10.2-9.8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M6.9,135.3c-4,2.3-6.5,6.6-6.3,11.2l.9,43.6c0,4.6,2.7,8.8,6.8,10.9,0,0,31.7,15.8,32.9,15.4-5.1-10.1-7.9-21.3-8.2-32.7-.2-19.4-3.3-47.6,6-65.1-1.3-.2-32.2,16.7-32.2,16.7h.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M357.4,117.8v39.1c0,17.3-14,31.3-31.3,31.3h-48.5c-8.9-31.1-41.2-49.1-72.3-40.2-19.5,5.6-34.7,20.8-40.2,40.2h-48.4c-17.3,0-31.3-14-31.3-31.3v-39.1c0-17.3,14-31.3,31.3-31.3h209.4c17.3,0,31.3,14,31.3,31.3h0ZM404.5,156.8c0,42.4-34.4,76.8-76.8,76.8h-68.4c-6,0-11.5-3.6-13.9-9.1l-11.3-26.2c-2.8-6.1-10-8.9-16.1-6.1-2.7,1.2-4.9,3.4-6.1,6.1l-11.4,26.1c-2.4,5.6-7.9,9.2-13.9,9.2h-68.3c-42.4-.1-76.7-34.4-76.8-76.8.5-21-3-54.2,7.9-72.9v-14.5c-.7-44.7,34-86,76.7-85.4h193.8c42.7-.6,77.3,40.7,76.7,85.3v14.6c10.9,18.5,7.4,52.1,7.9,72.9h0ZM372.5,117.8c0-25.7-20.8-46.4-46.5-46.5H116.6c-25.7,0-46.4,20.8-46.5,46.5v39.1c0,25.7,20.8,46.4,46.5,46.5h53.4c3,0,5.8-1.8,7-4.6l5.5-12.5c9.6-21.5,34.8-31.1,56.3-21.5,9.6,4.3,17.2,12,21.5,21.6l5.3,12.4c1.2,2.8,4,4.6,7,4.6h53.5c25.7,0,46.5-20.8,46.5-46.5v-39.1h0ZM379.5,62.7c-.7-8.1-2.6-16-5.6-23.5C365.1,15.9,343.2.1,318.3-.8H124.4c-33-.5-59.3,30.8-61.3,63.5,14.3-14,33.5-21.8,53.5-21.8h209.4c20,0,39.2,7.8,53.5,21.8ZM438.2,132.6s-32.2-14.2-33.5-13.9c10.8,16.6,10,45,11.5,64.3.7,11.3-1.1,22.7-5.4,33.2,1.3.2,31.5-18.1,31.5-18.1,3.9-2.4,6.2-6.8,5.9-11.4l-2.8-43.5c-.3-4.6-3.1-8.7-7.3-10.6h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3111",
    "data-name": "Layer_311",
    className: "st31"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st28",
    cx: 223,
    cy: 173.3,
    r: 141.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M65.3,101.5l-25.6,14.7c-4.1,2.4-6.7,7.1-6.7,12.1v47.5c0,5,2.5,9.7,6.7,12l25.7,14.8c-4.3-10.4-6.5-21.7-6.5-33,.4-19.9-2.3-49.9,6.4-68.1h0ZM378,169.6c0,38.2-29,69.2-64.8,69.3h-57.7c-5.1,0-9.6-3.2-11.7-8.2l-9.5-23.6c-2.3-5.5-8.4-8-13.7-5.5-2.2,1.1-4.1,3-5.1,5.5l-9.6,23.5c-2,5-6.6,8.3-11.8,8.3h-57.6c-35.7,0-64.7-31-64.8-69.3.4-18.9-2.5-48.9,6.6-65.8v-13.1c-.6-40.3,28.7-77.5,64.7-77h163.5c36-.5,65.2,36.7,64.7,76.9v13.1c9.2,16.7,6.3,46.9,6.6,65.8h.2,0ZM358.2,84.8c-.6-7.3-2.2-14.4-4.8-21.2-7.4-21.1-25.9-35.3-47-36.1h-163.5c-27.8-.4-50,27.8-51.6,57.3,12.1-12.6,28.2-19.7,45.1-19.6h176.7c16.8,0,33,7,45.1,19.6h0ZM416.4,116.2s-31.9-17.7-33.2-17.4c9.9,18.8,7.3,49.7,7.6,70.8,0,12.4-2.6,24.6-7.6,35.8,1.3.4,33.3-17.6,33.3-17.6,4.1-2.4,6.7-7,6.7-12v-47.5c0-5-2.5-9.7-6.7-12.1h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.3,221.2c11.3,29.1-7.8,43.2-33.6,49.2-24.2,5.6-50.6,3.3-75.3,3.3-3-1.5-2.2-9,.4-9.9s13,.6,17.3.6c30-.2,75.8-7.5,88.9-38.7.3-.8,1-5.8,2.3-4.5h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2111"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 181.6,
    y1: 81.4,
    x2: 264.5,
    y2: 81.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3111"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st30",
    cx: 223,
    cy: 173.3,
    r: 141.5
  })), /*#__PURE__*/React.createElement("image", {
    className: "st15",
    width: 322,
    height: 150,
    transform: "translate(64 197.3)",
    xlinkHref: "Logo-1.png"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_411"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M292.4,239.1c11.3,17.4-7.8,25.9-33.6,29.5-24.2,3.4-50.6,2-75.3,2-3-.9-2.2-5.4.4-5.9s13,.4,17.3.4c30-.1,75.8-4.5,88.9-23.2.3-.5,1-3.5,2.3-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.4,239.1c11.3,17.4-7.8,25.9-33.6,29.5-24.2,3.4-50.6,2-75.3,2-3-.9-2.2-5.4.4-5.9s13,.4,17.3.4c30-.1,75.8-4.5,88.9-23.2.3-.5,1-3.5,2.3-2.7h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "highlight"
  }, /*#__PURE__*/React.createElement("image", {
    className: "st15",
    width: 230,
    height: 125,
    transform: "translate(108 12.3)",
    xlinkHref: "Logo-2.png"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M371.1,103.8c9.2,16.7,7,46.9,6.9,65.8h-.2.2c0,38.2-29,69.2-64.8,69.3h-57.7c-5.1,0-9.6-3.2-11.7-8.2l-9.5-23.6c-2.3-5.5-8.4-8-13.7-5.5-2.2,1.1-4.1,3-5.1,5.5l-9.6,23.5c-2,5-6.6,8.3-11.8,8.3h-57.6c-35.7,0-64.7-31-64.8-69.3.4-18.9-2.5-48.9,6.6-65.8M146,103.8h-67.8c11-22.3,54.3-19.8,71.2-19.7h176.7c16.8,0,35,5.6,45,19.7h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M339.1,228.6c-14.2,6.8-30.4,6-46.2,6.3-7.5,0-16.6.7-25.1.7s-19,.3-22.6-9.6c-.7-4.4,4.1.9,6.1,2.5,2.9,2.4,6.6,3,10.2,3.1,4.7.1,9.7,0,14.5,0,14.3-.2,29.9.3,44.2-1.3,2.8-.3,5.9-.7,8.6-1.3,2.1-.4,20.2-6,10.7-.6l-.3.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.6,228.6c14.2,6.8,30.4,6,46.2,6.3,7.5,0,16.6.7,25.1.7s19,.3,22.6-9.6c.7-4.4-4.1.9-6.1,2.5-2.9,2.4-6.6,3-10.2,3.1-4.7.1-9.7,0-14.5,0-14.3-.2-29.9.3-44.2-1.3-2.8-.3-5.9-.7-8.6-1.3-2.1-.4-20.2-6-10.7-.6l.3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.1,107.5c33.2-13.2,84.3-11.3,123.5-11.8,38.6.2,81.2-.7,116.2,9.8,21.2,7.6-14.5,5.3-22.2,4.8-16.4-1.1-32.5-2-48.8-2.4-48.5-1.2-97.6-1.3-145.4,3.2-6.2.5-34.1,2.8-23.4-3.5h.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M396.4,137.9s-17.1-9.7-17.8-9.5c5.3,10.3,3.9,27.3,4.1,38.9,0,6.8-1.4,13.5-4.1,19.6.7.2,17.9-9.7,17.9-9.7,2.2-1.3,3.6-3.8,3.6-6.6v-26.1c0-2.7-1.3-5.3-3.6-6.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M53.6,137.9h0c-2.3,1.3-3.6,3.9-3.6,6.6v26.1c0,2.7,1.4,5.3,3.6,6.6,0,0,17.2,9.9,17.9,9.7-2.7-6.1-4.1-12.8-4.1-19.6.2-11.6-1.2-28.5,4.1-38.9-.7-.2-17.8,9.5-17.8,9.5h-.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("image", {
    className: "st15",
    width: 117,
    height: 108,
    transform: "translate(167 166.3)",
    xlinkHref: "Logo-3.png"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2a9747a0837c8327764afb187b72df1e.svg";
export { ForwardRef as ReactComponent };